'use client';
/**
 * Dependencies
 */
import React from 'react';
import Image from 'next/image';
import { CombinedShoppingModule } from '~/app/components/front-page-redesign/combined-shopping-module/combined-shopping-module';
import NerdWalletPlus from '~/app/components/front-page-redesign/nerdwallet-plus/nerdwallet-plus';
import SocialModule from '~/app/components/front-page-redesign/social-module/social-module';
import { Box, CenteredContainer, Text } from '@nerdwallet/currency';
import styles from './front-page-combined-container.module.scss';
import Testimonials from '~/app/components/front-page-redesign/testimonials';
import Articles from '~/app/components/front-page-redesign/articles';
import { NewsArticlesQuery } from '~/generated-graphql/generated-types';
import { TreasuryRates } from '~/app/queries/types';
import { ARROW_URL } from '~/app/components/front-page-redesign/combined-shopping-module/constants';
interface Props {
  articlesData?: NewsArticlesQuery | undefined;
  socialVideos?: string[] | undefined;
  treasuryRates?: TreasuryRates;
}

const FrontPageCombinedContainer = ({
  articlesData,
  socialVideos,
  treasuryRates,
}: Props) => {
  return (
    <Box className={styles.mainWrapper}>
      <CenteredContainer className={styles.combinedShoppingModuleWrapper}>
        <div className={styles.heading}>
          <div className={styles.headingTitle}>
            <Text component="h1" bold>
              <span className={styles.titleSize}>
                Financial decisions ahead? <br /> Let the Nerds do the work.
              </span>
            </Text>
            <div className={styles.arrow}>
              <Image src={ARROW_URL} alt="arrow" width={80} height={74} />
            </div>
          </div>
          <CombinedShoppingModule />
        </div>
      </CenteredContainer>
      <Articles articlesData={articlesData} alternativeVersion />
      <NerdWalletPlus
        showNerdWalletPlus
        showBestOfAwards={false}
        treasuryRates={treasuryRates}
      />
      <SocialModule socialVideos={socialVideos} />
      <Testimonials
        backgroundColor="#00482F"
        negativeTopMarginValue={53}
        treasuryRates={treasuryRates}
      />
    </Box>
  );
};

export default FrontPageCombinedContainer;
